module.exports = __webpack_public_path__ + "img/template16.0cb226f9.png";